module.exports = __webpack_public_path__ + "img/buddy_whiskers-02.6e64063d.svg";